export default __webpack_public_path__ + "static/media/Beijing Parkview - Logo.825ba8fb.png";